import * as z from 'zod'

export const EmailSchema = z.object({
	email: z.string().email(),
	alias: z.string().optional()
})

export type EmailType = z.TypeOf<typeof EmailSchema>